module.exports = __webpack_public_path__ + "static/img/5.98285b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/eng/5.png
// module id = hbPh
// module chunks = 0